import '../admin-user.scss';
import { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import Icon from '../../../components/icons/icon';
import { Typography } from '../../../components/typography/typography';
import { useAdminApiV1 } from '../../../clients/quipli-service/admin/admin-api-v1';
import { TenantContext } from '../../../context/tenant-context';
import { useAdmin } from '../../../hooks/use-admin-context';
import { toast } from '../../../util/toasts';
import { Button } from '../../../components/form/button';
import { RouteTabs } from '../../../components/tab-nav-v2/route-tabs';

export type AdminViewContext = { admin: Admin; isLoading: boolean; fetchAdmin: () => Promise<void> };

export const AdminView = () => {
  const navigate = useNavigate();
  const { adminId } = useParams();
  const { getUserAdmin } = useAdminApiV1();
  const { contextPath } = useContext(TenantContext);
  const { id: currentAdminId } = useAdmin();

  const [isLoading, setLoading] = useState<boolean>(true);
  const [admin, setAdmin] = useState<Admin>();

  const handleBack = () => {
    navigate(`${contextPath}manager/admins`);
  };

  const fetchAdmin = async () => {
    try {
      const admin = await getUserAdmin(parseInt(adminId!));
      setAdmin(admin);
    } catch (e: any) {
      const message =
        typeof e.message === 'object' && 'msg' in e.message
          ? e.message.msg
          : typeof e.message === 'string'
          ? e.message
          : 'Failed to fetch admin';

      toast(message, 'error');
      handleBack();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!adminId || isNaN(Number(adminId))) {
      handleBack();
      toast('Invalid admin id', 'error');
    }

    fetchAdmin();
  }, []);

  return (
    <div className="admin-user">
      <div className="container-v2">
        <div className="flex">
          <Button className="button-tertiary !pl-0" onClick={() => navigate(-1)} data-cy="back-button">
            <Icon icon="Back" size="large" />
          </Button>

          <Typography type="display-sm" weight="medium">
            Admin User Details
          </Typography>
        </div>

        <RouteTabs
          tabNames={
            currentAdminId === admin?.adminId
              ? ['Permissions', 'Email Settings']
              : ['Setup', 'Password', 'Permissions', 'Email Settings']
          }
          path="/admins/:adminId"
        />
        <div className="p-4">
          <Outlet context={{ admin, isLoading, fetchAdmin }} />
        </div>
      </div>
    </div>
  );
};
